import type { ToastSeverity } from '@/features/ui';

interface SignOutcome {
  message: string;
  severity: ToastSeverity;
}

/**
 * What to tell the director once a document is signed.
 *
 * Saving the signature is a second request that can fail on its own, and it
 * fails *after* the document is already signed. Reporting that as an error
 * would tell them the signing failed when it did not, so the outcome is worded
 * from both facts together rather than from whichever request answered last.
 */
export const signOutcome = (wantedSave: boolean, saved: boolean): SignOutcome => {
  if (!wantedSave) return { message: 'Document signed.', severity: 'success' };

  return saved
    ? { message: 'Document signed and signature saved.', severity: 'success' }
    : { message: 'Document signed, but the signature was not saved.', severity: 'warning' };
};
